

import img1 from '../../../assets/images/StockCake-MuscularArm.jpg'
import img2 from '../../../assets/images/StockCake1724428407.jpg'
import img3 from '../../../assets/images/StockCake-MorningYogaPractice.jpg'
import img4 from '../../../assets/images/StockCake-SereneMorningStretch.jpg'
import img5 from '../../../assets/images/StockCake-BeachMeditation.jpg'

var allProduct = [
    {
       key: "E11381DDCE6E4",
       previewImg: img1,
      
       title: "Musculation",
     
       price: "761.00",
       availability: "In stock",
       productCode: "0405689",
       brand: "Lee",
       tags: ["bags", "clothes", "shoes", "dresses"],
       des:
          "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing.",
    },
    {
       key: "B617D5334A7F4",
       previewImg: img2,
    
       title: "HIIT, Cardio",
      
       price: "159.00",
       availability: "In stock",
       productCode: "0405689",
       brand: "Lee",
       tags: ["bags", "clothes", "shoes", "dresses"],
       des:
          "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing.",
    },
    {
       key: "A5B1AC21CEFA9",
       previewImg: img3,
     
       title: "Yoga, Etirement",
     
       price: "357.00",
       availability: "In stock",
       productCode: "0405689",
       brand: "Lee",
       tags: ["bags", "clothes", "shoes", "dresses"],
       des:
          "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing.",
    },
    {
       key: "FB695A3B5CE53",
       previewImg: img4,
     
       title: "Echauffement, Recuperation",
    
       price: "654.00",
       availability: "In stock",
       productCode: "0405689",
       brand: "Lee",
       tags: ["bags", "clothes", "shoes", "dresses"],
       des:
          "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing.",
    },
    {
       key: "B3B5CE53F695A",
       previewImg: img5,
       
       title: "Respiration",
     
       price: "369.00",
       availability: "In stock",
       productCode: "0405689",
       brand: "Lee",
       tags: ["bags", "clothes", "shoes", "dresses"],
       des:
          "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing.",
    },
   /*  {
       key: "C21CEFA9A5B1A",
       previewImg: img1,
     
       title: "Seance d'entrainement personnalisées",
    
       price: "245.00",
       availability: "In stock",
       productCode: "0405689",
       brand: "Lee",
       tags: ["bags", "clothes", "shoes", "dresses"],
       des:
          "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing.",
    }, */
 
    
 ]
 export default allProduct;